import { API } from "../../../config";
import CONSTANTS, { LIST_LIMIT } from "../../../constants/constants";
import { OrderLevelDataWithPaginationType, ReportCardSummaryTypeWithLogsType,ProductLevelDataWithPaginationType, urlData} from "../../../interfaces/businessReportInterface";
import AxiosUtils from "../../../utils/AxiosUtils";
import Cookies from "../../../utils/Cookies";
import { serverAPIPath, mockAPIPath } from "../config/apiPath";
class BusinessReportDataApi {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;
    then: any;
    
    constructor(payload = {}, isHitDummyURL = false, isDemoUser = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = {
            "access-token": new Cookies("access-token").read(),
            ...(isDemoUser ? { "demo-user": CONSTANTS.DEMO_USER_CONSTANTS } : {})
        };
    }

    async productLevelDataCount(
        viewBy?: string,
        startDate?: string | null,
        endDate?: string | null,
        searchProduct?: string,
        searchCategory?: string,
        searchQuantity?: string,
        sort?: string,
        publicFlag?: string,
        favorite?: string,
        searchTotalSalesAmount?: string,
        searchProductBy?: string,
        searchCategoryBy?: string
    ): Promise<number> {
        // Skip HEAD in demo/mock mode — real API is not accessible for demo users
        if (this.isHitDummyURL) return 0;
        const response = await new AxiosUtils(
            `${API.BASE_URL}${serverAPIPath.PRODUCT_LEVEL_DATA}?viewBy=${viewBy}&startDate=${startDate}&endDate=${endDate}&searchProduct=${searchProduct}&searchCategory=${searchCategory}&searchQuantity=${searchQuantity}&sort=${sort}&publicFlag=${publicFlag}&favorite=${favorite}&searchTotalSalesAmount=${searchTotalSalesAmount}&searchProductBy=${searchProductBy}&searchCategoryBy=${searchCategoryBy}`,
            this.payload,
            this.headers
        ).head();
        return Number(response?.headers?.["x-total-count"] ?? 0);
    }

    async productLevelData(
        page_id: number,
        limit = LIST_LIMIT.BULK_PRODUCT_LIST,
        viewBy?:string,
        startDate?:string | null,
        endDate?:string | null,
        searchProduct?: string,
        searchCategory?: string,
        searchQuantity?: string,
        sort?:string,
        publicFlag?:string,
        favorite?:string,
        searchTotalSalesAmount?:string,
        searchProductBy?: string,
        searchCategoryBy?: string,
        refreshCount = false
    ) {

        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.PRODUCT_LEVEL_DATA}`,
                this.payload,
                this.headers
            ).getNew()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.PRODUCT_LEVEL_DATA}?page=${page_id}&limit=${limit}&viewBy=${viewBy}&startDate=${startDate}&endDate=${endDate}&searchProduct=${searchProduct}&searchCategory=${searchCategory}&searchQuantity=${searchQuantity}&sort=${sort}&publicFlag=${publicFlag}&favorite=${favorite}&searchTotalSalesAmount=${searchTotalSalesAmount}&searchProductBy=${searchProductBy}&searchCategoryBy=${searchCategoryBy}&refreshCount=${refreshCount}`,
                this.payload,
                this.headers
            ).getNew();
        if (response?.data?.success) {
            const productLevelData: ProductLevelDataWithPaginationType = {
                productLevelDataLogs: response.data.data.data,
                nextPage: response.data.data.nextPage === true,
                pagination: {
                    currentPage: 0,
                    totalPages: 0,
                    currentTotalCount: 0,
                    totalCount: 0,
                },
                templateUrl: response.data.data.templateUrl ?? ""
            };
            return productLevelData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async reportCardSummaryData(
        startDate?:string | null,
        endDate?:string | null,
        viewBy?:string,
    ) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.REPORT_CARD_SUMMARY}`,
                this.payload,
                this.headers
            ).getNew()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.REPORT_CARD_SUMMARY}?startDate=${startDate}&endDate=${endDate}&viewBy=${viewBy}`,
                this.payload,
                this.headers
            ).getNew();
        if (response?.data?.success) {
            const reportCardSummaryData:ReportCardSummaryTypeWithLogsType = {
                ReportCardSummaryLogs:response.data.data
            };
            return reportCardSummaryData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async orderLevelData(
        page_id: number,
        limit = LIST_LIMIT.BULK_PRODUCT_LIST,
        viewBy?:string,
        startDate?:string | null,
        endDate?:string | null,
        sort?: string,

    ) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.ORDER_LEVEL_DATA}`,
                this.payload,
                this.headers
            ).getNew()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.ORDER_LEVEL_DATA}?page=${page_id}&limit=${limit}&viewBy=${viewBy}&startDate=${startDate}&endDate=${endDate}&sort=${sort}`,
                this.payload,
                this.headers
            ).getNew();
        if (response?.data?.success) {
            const { currentPage, totalPages, currentTotalCount, totalCount, templateUrl } = response.data.data;
            const OrderLevelData: OrderLevelDataWithPaginationType = {
                OrderLevelDataLogs: response.data.data.data,
                pagination: {
                    currentPage,
                    totalPages,
                    currentTotalCount,
                    totalCount,
                },
                templateUrl
            };
            return OrderLevelData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }
    
    async downloadOrderLevelListData(
        startDate?:string | null,
        endDate?:string | null,
        fileType?:string,
        sort?: string,
        viewBy?:string
    ) {
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.ORDER_LEVEL_DATA}`,
                this.payload,
                this.headers
            ).getNew()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.ORDER_LEVEL_DATA}?startDate=${startDate}&endDate=${endDate}&fileType=${fileType}&download=true&sort=${sort}&viewBy=${viewBy}`,
                this.payload,
                this.headers
            ).getNew();
        if (response?.data?.success) {
            if(response?.data?.data) {
                const { data, currentPage, totalPages, currentTotalCount, totalCount, templateUrl } =
                    response.data.data;
                       
                const OrderLevelData: OrderLevelDataWithPaginationType = {
                    OrderLevelDataLogs: data,
                    pagination: {
                        currentPage,
                        totalPages,
                        currentTotalCount,
                        totalCount,
                    },
                    templateUrl
                };
                return OrderLevelData;
            } else {
                const message = response?.data?.message;
                return message;
            }
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async downloadProductLevelListData(
        startDate?:string | null,
        endDate?:string | null,
        fileType?:string,
        searchProduct?: string,
        searchCategory?: string,
        searchQuantity?: string,
        sort?:string,
        publicFlag?:string,
        favorite?:any,
        searchTotalSalesAmount?:string,
        viewBy?:string,
        totalCount?: number,
        searchProductBy?: string,
        searchCategoryBy?: string
    ) {
        const downloadHeaders = {
            ...this.headers,
            ...(totalCount !== undefined ? { "x-total-count": totalCount } : {})
        };
        const response = this.isHitDummyURL
            ? await new AxiosUtils(
                `${mockAPIPath.PRODUCT_LEVEL_DATA}`,
                this.payload,
                downloadHeaders
            ).getNew()
            : await new AxiosUtils(
                `${API.BASE_URL}${serverAPIPath.PRODUCT_LEVEL_DATA}?startDate=${startDate}&endDate=${endDate}&fileType=${fileType}&download=true&searchProduct=${searchProduct}&searchCategory=${searchCategory}&searchQuantity=${searchQuantity}&sort=${sort}&publicFlag=${publicFlag}&favorite=${favorite}&searchTotalSalesAmount=${searchTotalSalesAmount}&viewBy=${viewBy}&searchProductBy=${searchProductBy}&searchCategoryBy=${searchCategoryBy}`,
                this.payload,
                downloadHeaders
            ).getNew();
        if (response?.data?.success) {
            if(response?.data?.data) {
                // Backend returns only { data: productsData } — pagination fields are not in response
                const productLevelData: ProductLevelDataWithPaginationType = {
                    productLevelDataLogs: response.data.data.data,
                    templateUrl: ""
                };
                return productLevelData;
            } else {
                const message = response?.data?.message;
                return message;
            }
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async downloadBusinessReportResponseCheck(url:any) {
        try {
            const response = await new AxiosUtils(url).head();
            if(response?.status==200){
                return true;
            }else{
                return false;
            } 
        } catch (error: any) {
            return false;
        }  
    }

    async linkRegisterUrl(linkToken:any) {
        const response = await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.LINK_REGISTER_URL}?linkToken=${linkToken}`,this.payload,this.headers).get();
        if(response?.data?.success){
            const businessReportUrlData: urlData =   response.data.data;
            return businessReportUrlData;
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }  
    }
}

export default BusinessReportDataApi;

